<template>
  <div class="selectBlock">
    <div class="headerText">
      {{
        getTranslation(
          $store,
          "MenuComponent",
          "headline",
          activeComponent.id,
          activeComponent.headline
        )
      }}
    </div>
    <div class="productBlock">
      <product-list
        :itemIds="itemIds"
        :activeCombo="this.activeCombo"
        :menuOffset="true"
        @onAddBasket="addToCombo"
      />
    </div>
  </div>
</template>
<script>
import { mapGetters, mapMutations, mapActions } from "vuex";
import {
  productToBasketItem,
  createNewObject,
  addProductToBasket,
  combineProductsToMenu
} from "@/utils/products";
import {
  getTranslatedMenuName,
  getTranslation,
  setFixedPrice
} from "@/utils/helpers";

import ProductList from "@/components/menu/ProductList.vue";

export default {
  components: {
    ProductList
  },
  props: ["component", "changeComponent", "currentComponent"],
  data() {
    return {
      locked: false,
      activeName: "",
      activeHeadline: "",
      activeItems: [],
      requested_component: null,
      activeComponent: null
    };
  },
  created() {
    this.performProductPreselection();
    this.requested_component = this.component;
    const result = this.activeCombo.components.find(item => !item.selected);
    if (result && result.id) {
      this.goTo(result);
    } else {
      this.logRouter({ name: "order", router: this.$router });
    }
  },
  watch: {
    component(newVal) {
      this.requested_component = newVal;
      if (newVal && newVal.id) {
        const result = this.activeCombo.components.find(
          item => item.id === newVal.id
        );
        if (result) {
          this.goTo(result);
        }
      }
    }
  },
  computed: {
    ...mapGetters({
      activeCombo: "ACTIVE_COMBO",
      basket: "BASKET",
      productsList: "PRODUCTS_FILTERED",
      menus: "MENUS"
    }),
    itemIds() {
      return this.activeItems.map(item => item.id);
    }
  },
  methods: {
    /**
     * Iterate unselected menu components and preselect product of menu component
     * if only one product is available and extras and sizes are not selectable.
     */
    performProductPreselection() {
      if (this.activeCombo && this.activeCombo.components) {
        let unselectedMenuComponents = this.activeCombo.components.filter(
          component => !component.selected
        );
        unselectedMenuComponents.forEach(menuComponent => {
          const available_product_ids = menuComponent.available_products.map(
            item => item.id
          );
          let available_products_not_hidden = this.productsList.filter(
            active_product => available_product_ids.includes(active_product.id)
          );
          if (
            available_products_not_hidden &&
            available_products_not_hidden.length == 1
          ) {
            let product = available_products_not_hidden[0];
            if (product) {
              let sizesAvailable =
                product.available_sizes && product.available_sizes.length > 0;
              let extrasAvailable = product.extras && product.extras.length > 0;
              if (!sizesAvailable && !extrasAvailable) {
                console.log(
                  "performProductPreselection for product id:" + product.id
                );
                this.activeComponent = menuComponent;
                this.addToCombo(product);
              }
            }
          }
        });
      }
    },
    getTranslation,
    goTo(component) {
      this.activeComponent = component;
      const available_product_ids = component.available_products.map(
        item => item.id
      );
      this.activeItems = this.productsList.filter(
        item => available_product_ids.indexOf(item.id) !== -1
      );
    },
    onlyOneProductLeft(combo) {
      console.log("comboProductCount");
      const product_items = combo.components.filter(
        item => !item.selected.no_product
      );
      return product_items.length === 1;
    },
    finalizeCombo(combo) {
      setFixedPrice(combo);
      combo.name = getTranslatedMenuName(this.$store, combo);

      if (!combo.count) {
        combo.count = 1;
      }

      if (this.onlyOneProductLeft(combo)) {
        // if menu contains only one product add it to basket and check for possible menus
        let singleProduct = combo.components[0].selected;
        singleProduct.uid = combo.uid;
        this.logAudit({
          category: "CART",
          event: "ADD_PRODUCT",
          data: singleProduct
        });
        let newBasket = addProductToBasket(singleProduct, this.basket);
        newBasket = combineProductsToMenu(this.menus, newBasket);
        this.setBasket(newBasket);
      } else {
        this.logAudit({
          category: "CART",
          event: "ADD_PRODUCT",
          data: combo
        });
        const newBasket = addProductToBasket(combo, this.basket);
        this.setBasket(newBasket);
      }

      this.locked = true;
      setTimeout(() => {
        this.setActiveCombo({});
        this.logRouter({ name: "order", router: this.$router });
      }, 500);
    },
    progress(combo) {
      const result = combo.components.find(item => !item.selected);
      if (result && result.id) {
        this.$emit("changeComponent", { id: result.id });
        this.goTo(result);
      } else {
        this.finalizeCombo(combo);
      }
    },
    addToCombo(product) {
      if (this.locked) return;
      const basketItem = productToBasketItem(product);
      const newCombo = {
        ...this.activeCombo,
        components: this.activeCombo.components.map(item => ({ ...item }))
      };
      newCombo.components.forEach(item => {
        if (item.id === this.activeComponent.id) {
          item.selected = basketItem;
        }
      });
      this.logAudit({
        category: "COMBO",
        event: "SELECTED_COMPONENT",
        data: basketItem
      });
      this.setActiveCombo(newCombo);
      this.progress(newCombo);
    },
    addMultiToCombo(product, action) {
      if (this.locked) return;
      const basketItem = productToBasketItem(product);
      const newCombo = createNewObject(this.activeCombo);
      this.activeItems.map(item => {
        if (item.id === basketItem.id) {
          item.selected = Boolean(Number(action));
        }
      });
      newCombo.components.forEach(item => {
        if (item.name === this.activeName) {
          if (Number(action)) {
            // when action = 1 it's add action
            if (item.selectedArray && item.selectedArray.length) {
              item.selectedArray = [...item.selectedArray, basketItem];
            } else {
              item.selectedArray = [basketItem];
              item.selected = basketItem;
            }
          } else {
            // Remove action
            item.selectedArray = item.selectedArray.filter(
              item => item.id !== basketItem.id
            );
          }
        }
      });
      this.setActiveCombo(newCombo);
    },
    confirmBtn() {
      this.progress(this.activeCombo);
    },
    ...mapMutations({
      setCurrentCategory: "SET_CURRENT_CATEGORY",
      setBasket: "SET_BASKET",
      setActiveCombo: "SET_ACTIVE_COMBO"
    }),
    ...mapActions({ logRouter: "LOG_ROUTER", logAudit: "LOG_AUDIT" })
  }
};
</script>
<style lang="scss" scoped>
.selectBlock {
  margin: 25px 130px 0px;
}
.headerText {
  color: var(--component_combo_selectCombo_headerText_color);
  text-transform: var(--component_combo_selectCombo_headerText_text-transform);
  font-family: var(--component_combo_selectCombo_headerText_font-family);
  font-size: var(--component_combo_selectCombo_headerText_font-size);
  margin-bottom: 30px;
  text-align: center;
}
.productBlock {
  display: flex;
  justify-content: center;
}

.productBlock .productList {
  height: 900px !important;
}

.confirmBtn {
  width: 210px;
  height: 70px;
  border-radius: 35px;
  letter-spacing: 1px;
  color: #ffffff;
  font-family: var(--app_font-family-light);
  font-size: 20px;
  display: flex;
  justify-content: center;
  align-items: center;
  background: #f39a00;
}
</style>
